<template>
  <Produtos
    ref="produtosRef"
    :Edicao="Edicao"
    :nomeAbaProdutos="nomeAbaProdutos"
    tipoCliente="Pessoa Física"
  />
</template>

<script>
import Produtos from "../Shared/Produtos.vue";

export default {
  name: "CadastroPF_Produtos",
  props: ["Edicao", "nomeAbaProdutos"],
  components: { Produtos },
  methods: {
    proximaEtapa() {
      this.$refs.produtosRef.proximaEtapa();
    },
    validarFormulario() {
      return this.$refs.produtosRef.validarFormulario();
    },
  },
};
</script>
